// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assignBtn{
border-radius: 5px;
    height: 27px;
    border: 1px solid lightgray;
    background-image: linear-gradient(to top, rgb(227, 226, 226), white);
    color: black;
    border-bottom: black;
}`, "",{"version":3,"sources":["webpack://./src/Css/SummaryOrder.css"],"names":[],"mappings":"AAAA;AACA,kBAAkB;IACd,YAAY;IACZ,2BAA2B;IAC3B,oEAAoE;IACpE,YAAY;IACZ,oBAAoB;AACxB","sourcesContent":[".assignBtn{\r\nborder-radius: 5px;\r\n    height: 27px;\r\n    border: 1px solid lightgray;\r\n    background-image: linear-gradient(to top, rgb(227, 226, 226), white);\r\n    color: black;\r\n    border-bottom: black;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
